export const errors = {
  // Authentication errors
  AUTH_INVALID_CREDENTIALS: '認證資訊無效',
  AUTH_INCORRECT_PASSWORD: '目前密碼不正確',
  AUTH_ACCOUNT_LOCKED: '帳戶已鎖定，請稍後再試。',
  AUTH_ACCOUNT_DISABLED: '帳戶已停用',
  AUTH_2FA_REQUIRED: '需要雙重驗證碼',
  AUTH_INVALID_2FA: '雙重驗證碼無效',
  TURNSTILE_REQUIRED: '請完成驗證後再試一次。',
  TURNSTILE_FAILED: '驗證失敗，請再試一次。',
  TURNSTILE_NOT_CONFIGURED: '驗證服務暫時無法使用，請稍後再試。',
  AUTH_USER_NOT_FOUND: '找不到使用者',
  AUTH_TOKEN_EXPIRED: '會話已過期，請重新登入。',
  AUTH_INVALID_TOKEN: '無效或過期的權杖',
  AUTH_2FA_ALREADY_ENABLED: '雙重驗證已啟用或找不到使用者',
  AUTH_2FA_NOT_INITIATED: '雙重驗證設定尚未開始',
  AUTH_2FA_NOT_ENABLED: '使用者未啟用雙重驗證',
  AUTH_REQUIRED: '需要驗證',
  AUTH_INSUFFICIENT_PERMISSIONS: '此操作權限不足',
  AUTH_USER_INACTIVE: '使用者帳戶已停用',

  // User management errors
  USER_NOT_FOUND: '找不到使用者',
  USER_ALREADY_EXISTS: '使用者已存在',
  USER_EMAIL_IN_USE: '電子郵件已被使用',
  USER_USERNAME_IN_USE: '使用者名稱已被使用',
  USER_CANNOT_DELETE_SELF: '您無法刪除自己的帳戶',
  USER_INVALID_ROLE: '無效的角色',
  USER_INACTIVE: '使用者帳戶已停用',
  USER_UPDATE_FAILED: '更新使用者失敗',
  USER_DELETE_FAILED: '刪除使用者失敗',

  // Validation errors
  VALIDATION_FAILED: '驗證失敗',
  VALIDATION_REQUIRED_FIELD: '此欄位為必填',
  VALIDATION_INVALID_EMAIL: '無效的電子郵件格式',
  VALIDATION_PASSWORD_TOO_WEAK: '密碼必須包含至少一個大寫字母、一個小寫字母、一個數字和一個特殊字元',
  VALIDATION_PASSWORDS_NOT_MATCH: '密碼不符',
  VALIDATION_MISSING_FIELD: '必填欄位缺失',
  VALIDATION_INVALID_FORMAT: '欄位格式無效',
  VALIDATION_OUT_OF_RANGE: '數值超出允許範圍',

  // Permission errors
  PERMISSION_DENIED: '權限被拒絕',
  PERMISSION_INSUFFICIENT: '權限不足',

  // Settings errors
  SETTINGS_NOT_FOUND: '找不到設定',
  SETTINGS_UPDATE_FAILED: '更新設定失敗',
  SETTINGS_INVALID_VALUE: '無效的設定值',
  SETTINGS_FILE_TOO_LARGE: '檔案大小超過限制',
  SETTINGS_INVALID_FILE_TYPE: '無效的檔案類型',

  // Charger errors
  CHARGER_NOT_FOUND: '找不到充電樁',
  CHARGER_OFFLINE: '充電樁離線',
  CHARGER_UNAVAILABLE: '充電樁不可用',
  CHARGER_OCCUPIED: '充電樁正被其他車輛使用',
  CHARGER_FAULTED: '充電樁發生故障',
  CHARGER_HAS_ACTIVE_SESSIONS: '充電樁有進行中的充電會話，無法刪除',
  CHARGER_STATION_ID_EXISTS: '站點 ID 已存在',
  CHARGER_REBOOT_FAILED: '重啟充電樁失敗',

  // Charger Type errors
  CHARGER_TYPE_NOT_FOUND: '找不到充電樁類型',
  CHARGER_TYPE_IN_USE: '充電樁類型正在使用中，無法刪除',
  CHARGER_TYPE_NAME_EXISTS: '充電樁類型名稱已存在',

  // Load Group errors
  LOAD_GROUP_NOT_FOUND: '找不到負載群組',
  LOAD_GROUP_HAS_CHARGERS: '負載群組包含充電樁，無法刪除',
  LOAD_GROUP_NAME_EXISTS: '負載群組名稱已存在',

  // Connector errors
  CONNECTOR_NOT_FOUND: '找不到連接器',
  CONNECTOR_CABLE_NOT_CONNECTED: '充電線未連接，請先連接充電線。',
  CONNECTOR_ALREADY_CHARGING: '連接器已在充電中',
  CONNECTOR_FINISHING: '上一次充電正在結束，請稍候。',
  CONNECTOR_UNAVAILABLE: '連接器不可用',
  CONNECTOR_FAULTED: '連接器發生故障',
  CONNECTOR_NOT_READY: '連接器尚未準備好充電',
  CONNECTOR_VERIFICATION_FAILED: '連接器就緒驗證失敗',

  // Session errors
  SESSION_NOT_FOUND: '找不到充電會話',
  SESSION_ALREADY_ACTIVE: '已有進行中的充電會話',
  SESSION_NOT_ACTIVE: '沒有進行中的充電會話',
  SESSION_NOT_STOPPABLE: '目前無法停止充電會話',
  SESSION_INIT_FAILED: '初始化充電會話失敗',
  SESSION_START_FAILED: '啟動充電會話失敗',
  SESSION_STOP_FAILED: '停止充電會話失敗',
  SESSION_ALREADY_COMPLETED: '充電會話已完成',
  SESSION_FORCE_COMPLETE_FAILED: '強制完成會話失敗',

  // Fee errors
  FEE_SCHEDULE_NOT_FOUND: '此充電樁未設定有效的費率方案',
  FEE_STRUCTURE_INVALID: '費率方案設定無效',
  FEE_TEMPLATE_NOT_FOUND: '找不到費率範本',
  FEE_TEMPLATE_IN_USE: '費率範本正在使用中，無法刪除',
  FEE_TEMPLATE_NAME_EXISTS: '費率範本名稱已存在',
  FEE_CALCULATION_FAILED: '費用計算失敗',
  FEE_SCHEDULE_OVERLAPPING: '費率時段與現有時段重疊',
  FEE_SCHEDULE_ACTIVE: '費率時段正在使用中，無法刪除',
  FEE_ADJUSTMENT_NOT_FOUND: '找不到費用調整',
  FEE_ADJUSTMENT_ALREADY_APPLIED: '費用調整已套用',
  FEE_CHANGE_ALREADY_PROCESSED: '費用變更已處理',

  // OCPP errors
  OCPP_SERVER_NOT_FOUND: '找不到 OCPP 伺服器',
  OCPP_SERVER_NOT_CONFIGURED: '此充電樁未設定 OCPP 伺服器',
  OCPP_SERVER_INACTIVE: 'OCPP 伺服器目前不可用',
  OCPP_SERVER_AUTH_FAILED: 'OCPP 伺服器驗證失敗',
  OCPP_SERVER_HAS_CHARGERS: 'OCPP 伺服器包含充電樁，無法刪除',
  OCPP_SERVER_ENDPOINT_EXISTS: 'OCPP 伺服器端點 URL 已存在',
  OCPP_COMMUNICATION_FAILED: '與 OCPP 伺服器通訊失敗',
  OCPP_COMMAND_REJECTED: 'OCPP 指令被充電樁拒絕',
  OCPP_COMMAND_TIMEOUT: 'OCPP 指令逾時',
  OCPP_TEMPLATE_NOT_FOUND: '找不到 OCPP 範本',
  OCPP_TEMPLATE_IN_USE: 'OCPP 範本正在使用中，無法刪除',
  OCPP_TEMPLATE_NAME_EXISTS: 'OCPP 範本名稱已存在',

  // LMS Template errors
  LMS_TEMPLATE_NOT_FOUND: '找不到 LMS 範本',
  LMS_TEMPLATE_IN_USE: 'LMS 範本正在使用中，無法刪除',
  LMS_TEMPLATE_NAME_EXISTS: 'LMS 範本名稱已存在',

  // Supabase Connection errors
  SUPABASE_CONNECTION_NOT_FOUND: '找不到 Supabase 連線',
  SUPABASE_CONNECTION_FAILED: 'Supabase 連線測試失敗',
  SUPABASE_CONNECTION_IN_USE: 'Supabase 連線正在使用中，無法刪除',
  SUPABASE_CONNECTION_NAME_EXISTS: '已存在相同名稱的 Supabase 連線',

  // Site errors
  SITE_NOT_FOUND: '找不到站點',
  SITE_INACTIVE: '站點已停用',
  SITE_HAS_CHARGERS: '站點包含充電樁，無法刪除',
  SITE_HAS_KIOSKS: '場地有付款亭記錄，無法刪除',
  SITE_NAME_EXISTS: '站點名稱已存在',

  // Role errors
  ROLE_NOT_FOUND: '找不到角色',
  ROLE_IN_USE: '角色已分配給使用者，無法刪除',
  ROLE_NAME_EXISTS: '角色名稱已存在',

  // Vendor errors
  VENDOR_NOT_FOUND: '找不到供應商',
  VENDOR_HAS_SITES: '供應商包含站點，無法刪除',
  VENDOR_HAS_HISTORY: '此商戶有 API 或充電紀錄，無法刪除。請改為停用。',
  VENDOR_NAME_EXISTS: '供應商名稱已存在',

  // App User errors
  APP_USER_NOT_FOUND: '找不到應用程式使用者',
  APP_USER_HAS_BALANCE: '應用程式使用者還有餘額',
  APP_USER_HAS_ACTIVE_SESSIONS: '應用程式使用者有進行中的充電會話',

  // RFID errors
  RFID_USER_NOT_FOUND: '找不到 RFID 使用者',
  RFID_USER_EMAIL_EXISTS: 'RFID 使用者電子郵件已存在',
  RFID_USER_HAS_CARDS: 'RFID 使用者有卡片，無法刪除',
  RFID_CARD_NOT_FOUND: '找不到 RFID 卡片',
  RFID_CARD_NUMBER_EXISTS: 'RFID 卡片號碼已存在',
  RFID_CARD_HAS_TRANSACTIONS: 'RFID 卡片有交易紀錄，無法刪除',

  // Promotion errors
  PROMOTION_NOT_FOUND: '找不到促銷活動',
  PROMOTION_CODE_EXISTS: '促銷代碼已存在',
  PROMOTION_HAS_REDEMPTIONS: '促銷活動已有兌換紀錄，無法刪除',

  // Banner errors
  BANNER_NOT_FOUND: '找不到橫幅',

  // Message errors
  MESSAGE_NOT_FOUND: '找不到訊息',
  MESSAGE_NO_RECIPIENTS: '未指定訊息接收者',
  MESSAGE_SEND_FAILED: '傳送訊息失敗',

  // Notification errors
  NOTIFICATION_GROUP_NOT_FOUND: '找不到通知群組',
  NOTIFICATION_GROUP_HAS_MEMBERS: '通知群組包含成員，無法刪除',
  NOTIFICATION_GROUP_NAME_EXISTS: '通知群組名稱已存在',

  // File errors
  FILE_TOO_LARGE: '檔案大小超過限制',
  FILE_INVALID_TYPE: '無效的檔案類型',
  FILE_UPLOAD_FAILED: '檔案上傳失敗',

  // Firmware errors
  FIRMWARE_NOT_FOUND: '找不到韌體',
  FIRMWARE_VERSION_EXISTS: '韌體版本已存在',
  FIRMWARE_IN_USE: '韌體正在使用中，無法刪除',
  FIRMWARE_UPDATE_NOT_FOUND: '找不到韌體更新',
  FIRMWARE_UPDATE_NO_CHARGERS: '沒有符合條件的充電樁可進行韌體更新',
  FIRMWARE_UPDATE_ALREADY_COMPLETED: '韌體更新已完成',

  // Resource errors
  RESOURCE_NOT_FOUND: '找不到資源',
  RESOURCE_ALREADY_EXISTS: '資源已存在',
  RESOURCE_IN_USE: '資源正在使用中，無法修改',
  RESOURCE_CREATE_FAILED: '建立資源失敗',
  RESOURCE_UPDATE_FAILED: '更新資源失敗',
  RESOURCE_DELETE_FAILED: '刪除資源失敗',

  // Database errors
  DATABASE_ERROR: '資料庫發生錯誤',
  DATABASE_CONNECTION_FAILED: '資料庫連線失敗',
  DATABASE_QUERY_FAILED: '資料庫查詢失敗',
  DATABASE_CONSTRAINT_VIOLATION: '資料庫約束違規',

  // External service errors
  EXTERNAL_SERVICE_ERROR: '外部服務錯誤',
  EXTERNAL_SERVICE_TIMEOUT: '外部服務逾時',
  EXTERNAL_SERVICE_UNAVAILABLE: '外部服務不可用',

  // General errors
  INTERNAL_ERROR: '發生內部錯誤',
  NETWORK_ERROR: '網路錯誤，請檢查您的連線。',
  UNKNOWN_ERROR: '發生未知錯誤',
  SERVICE_UNAVAILABLE: '服務暫時不可用',
  OPERATION_FAILED: '操作失敗',
  RATE_LIMIT_EXCEEDED: '請求次數超過限制，請稍後再試。',
  INVALID_REQUEST: '無效的請求',
};